import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SfaSalesLeadContactLinkContainerModel } from "../../../../../../models/aggregates/sfa/salesLead/SfaSalesLeadContactLinkContainer.model";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";

@Injectable({
    providedIn: 'root'
    })
    export class SfaSalesLeadContactLinkService extends BaseApiTemplateService<SfaSalesLeadContactLinkContainerModel> {

    readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'sales-lead-contact-links';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'sales-lead-contact-links';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'sales-lead-contact-links';
        this.httpClient = http;
    }
    }